import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../../../../services/common/common.service';
import { CompanyService } from '../../../../../services/company/company.service';
import { AuthService } from '../../../../../services/auth.service';
import { FieldMappingService } from '../../../../../services/field-mapping/field-mapping.service';
import { MenuService } from '../../../../../services/menus/menu.service';

@Component({
  selector: 'app-field-mapping',
  templateUrl: './field-mapping.component.html',
  styleUrl: './field-mapping.component.scss'
})
export class FieldMappingComponent implements OnInit {
  // List data
  listData: any = [];
  isFirstLoad = true;
  viewType: 'grid' | 'list' = 'list';
  menuId: number = 0;
  myColumns: any = [];

  // Pagination properties
  page = 0;
  pageSize = 10;
  size: any = 10;
  totalRecords: number = 0;
  currentPage: number = 0;
  currentFilters: any = null;

  // Component state
  hideCompany: boolean = false;
  dateFormat: string = 'dd/MM/yyyy';
  date: any = ''
  search: string = '';
  angularDateFormat: string = '';

  constructor(
    private readonly fieldMappingService: FieldMappingService,
    private readonly router: Router,
    private readonly commonService: CommonService,
    private readonly companyService: CompanyService,
    private readonly auth: AuthService,
    private readonly menuService: MenuService,
    private readonly route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.menuId = this.auth.selectedMenuID ?? 0;
    // const menuName = this.route.snapshot.data['breadcrumb'];
    // if (menuName) {
    //   this.getMenuIdByName(menuName);
    // }
    this.setupComponent();
    this.list();
  }

  private setupComponent(): void {
    const userData: any = this.commonService.getLocalStorageData();
    if (userData) {
      if (!userData.client) {
        this.hideCompany = true;
      }
      this.getDateFormat(userData.companyID);
    }
  }

  private getDateFormat(companyId: number): void {
    this.companyService.getParametersById(companyId).subscribe({
      next: (resp) => {
        if (resp?.data?.date_format) {
          this.dateFormat = resp?.data?.date_format.replace('mm', 'MM');
          this.date = resp?.data?.date_format;
          this.angularDateFormat = this.commonService.convertPrimeNGToAngularFormat(this.date);
        }
      },
    });
  }
  // getMenuIdByName(menuName: string): void {
  //   this.menuService.getAllMenus().subscribe({
  //     next: (res: any) => {
  //       if (res?.data && Array.isArray(res.data)) {
  //         const menu = res.data.find(
  //           (m: any) => m.name?.trim().toLowerCase() === menuName.toLowerCase(),
  //         );

  //         if (menu) {
  //           this.menuId = menu.id;
  //           // console.log(`📦 Menu ID found for "${menuName}":`, this.menuId);
  //         } else {
  //           console.warn(`⚠️ No matching menu found for "${menuName}"`);
  //           this.menuId = 0;
  //         }
  //       } else {
  //         console.error('❌ Invalid response from getAllMenus()');
  //       }
  //     },
  //     error: (err) => {
  //       console.error('❌ Failed to load menu list', err);
  //     },
  //   });
  // }
  handleFilterChange(payload: any) {
    if (payload) {
      if (payload.orderby !== undefined) this.currentSortField = payload.orderby;
      if (payload.order !== undefined) this.currentSortOrder = payload.order;
      if (payload.filters !== undefined) this.currentFilters = payload.filters;
      if (payload.page !== undefined) {
        this.currentPage = payload.page;
        this.page = payload.page + 1;
      }
      if (payload.pageSize !== undefined) {
        this.pageSize = payload.pageSize;
        this.size = payload.pageSize;
      }
    }
    this.list();
  }
  onViewChange(type: 'grid' | 'list') {
    this.viewType = type;
  }
  currentSortOrder: 'asc' | 'desc' = 'desc';
  currentSortField: any = 'id';
  loading: boolean = true;
  list(): void {
    this.loading = true;
    const params = this.paramData(this.currentPage.toString(), this.size.toString(), this.search, this.currentFilters);

    params['orderby'] = this.currentSortField || 'id';
    params['order'] = this.currentSortOrder || 'desc';
    this.fieldMappingService.getFieldMappingListWithPagi(params).subscribe({
      next: (response: any) => {
        if (response) {
          this.listData = response?.data?.rows || [];
          this.totalRecords = response?.data?.totalItems;
          this.currentPage = response?.data?.currentPage;
        }
      }
    });
  }
  paramData(page: any, size: any, search: any, filters: any) {
    let params = { page: this.currentPage, size: this.pageSize, search: this.search };
    if (page) params['page'] = page;
    if (size) params['size'] = size;
    if (search) params['search'] = search;
    const filterParams = this.buildFilterPayload(filters);
    return { ...params, ...filterParams };
  }
  buildFilterPayload(payloadData: any): any {
    const result: any = {};

    for (const key in payloadData) {
      if (payloadData.hasOwnProperty(key)) {
        const field = payloadData[key];

        if (Array.isArray(field) && field.length > 0) {
          field.forEach((item: any, index: number) => {
            let filterKey = key;
            let value: any;

            if (filterKey.startsWith('createdBy.') || filterKey.startsWith('updatedBy.')) {
              filterKey = filterKey.split('.')[0];
            }

            if (typeof item === 'object' && item !== null && 'value' in item) {
              value = item.value;

              if (
                (filterKey === 'createdBy' || filterKey === 'updatedBy') &&
                typeof value === 'object' &&
                value !== null
              ) {
                value = value.id ?? '';
              }

              result[`filters[${filterKey}][${index}][value]`] = value;
              result[`filters[${filterKey}][${index}][matchMode]`] =
                item.matchMode || 'contains';
            } else {
              // Keep original behavior for all others
              result[`filters[${filterKey}][${index}][value]`] = item;
              result[`filters[${filterKey}][${index}][matchMode]`] = 'contains';
            }
          });
        }
      }
    }

    return result;
  }
  searchTable(event: any): void {
    this.search = event.target.value;
    this.currentPage = 0;
    this.page = 1;
    this.list();
  }

  handlePageChange(event: number): void {
    if (this.isFirstLoad) {
      this.isFirstLoad = false;
      return;
    }
    this.currentPage = event && event > 0 ? event - 1 : 0;
    this.page = event;
    this.list();
  }

  checkPermission(type: string) {
    return this.auth.checkPermission(type);
  }

  navigateTo(leaveId: string) {
    this.router.navigate(['/app/attendance/field-mapping/edit/', leaveId]);
  }

}


